import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPharmacistInfo } from "../common/getPharmacyInfo";
import { getTimeDifference } from "../../../helpers/functions";
import { getCurrentUserDetails } from "../../../redux/modules/user/actions";
import { Section, H2, DataField } from "./common-components";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const PrescribingPharmacistInformation = ({ formType, startDateTime, endDateTime }) => {
  const { currentLoggedInUserDetail: userFromCurrentState } = useSelector((state) => state.currentLoggedInUserDetail ?? {});
  const usersState = useSelector((state) => state.users);
  const { currentLoggedInUserDetail: userFromUsers } = usersState ?? {};
  const currentLoggedInUserDetail = userFromCurrentState ?? userFromUsers;
  const dispatch = useDispatch();

  const pharmacist = getPharmacistInfo(currentLoggedInUserDetail) ?? {};
  const pharmacistName = pharmacist.pharmacistName ?? "-";
  const pharmacistSignature = pharmacist.pharmacistSignatureUrl ?? null;
  const pharmacistLicenseNumber = pharmacist.pharmacistLicenseNumber ?? "";

  useEffect(() => {
    if (!currentLoggedInUserDetail) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
      const userId = userInfo.userId;
      if (userId) {
        dispatch(getCurrentUserDetails(userId, false));
      }
    }
  }, [currentLoggedInUserDetail, dispatch]);
  
  // Forms that should show Time Spent (and should not be treated as intervention forms)
  const formsWithTimeSpent = [
    AllergicRhinitisDocTypes.InitialAssessment,
    AllergicRhinitisDocTypes.PrescribingRecord,
    AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
    MedicationReviewDocTypes.PharmacistWorksheet
  ];
  
  const isInterventionForm = (() => {
    if (!formType) return false;
    if (formsWithTimeSpent.includes(formType)) return false;
    const lowerFormType = formType.toLowerCase();
    return lowerFormType.includes("intervention") || lowerFormType.includes("prescribing");
  })();

  return (
    <Section 
    className={[AllergicRhinitisDocTypes.PrescribingRecord, AllergicRhinitisDocTypes.PrescribingRecordWithReferral].includes(formType) 
    && "bg-teal-25"} formType={formType}>
      {!isInterventionForm && <H2>Pharmacist Information</H2>}
      <div className="grid grid-cols-2 gap-x-10">
        {isInterventionForm ? (
          <>
            <DataField label="Pharmacist Name" value={pharmacistName} />
            <DataField label="Pharmacist License Number" value={pharmacistLicenseNumber} />
          </>
        ) : (
          <>
            <DataField label="Pharmacist Name" value={pharmacistName} />
            {formsWithTimeSpent.includes(formType) ? (
              <DataField label="Time Spent" value={getTimeDifference(startDateTime, endDateTime)} />
            ) : null}
            <DataField label="Pharmacist License Number" value={pharmacistLicenseNumber} />
            <DataField
              className="flex-nowrap items-center -mt-1"
              label="Pharmacist Signature"
              value={
                pharmacistSignature ? (
                  <img
                    src={pharmacistSignature}
                    alt="Pharmacist Signature"
                    className="max-h-[30px] max-w-[150px] object-contain align-middle"
                  />
                ) : (
                  ""
                )
              }
            />
          </>
        )}
      </div>
    </Section>
  );
};
